// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"TreadDepth_buttonsWrapper__1TYlb","intervalButtons":"TreadDepth_intervalButtons__YJGCC"};